import React from 'react';
import classNames from 'classnames/bind';
import { shape } from 'prop-types';
import { Alert } from '@thd-olt-component-react/alert';
import { getAlertBannerDetails } from '../../car-picker-helpers';
import styles from './automotive-banner.module.scss';

const AutomotiveBanner = ({ fitment }) => {

  const { message, type } = getAlertBannerDetails('browse', fitment);
  const classes = classNames.bind(styles);

  return (
    <div className={classes('automotive-banner')}>
      <Alert type={type} message={message} />
    </div>
  );
};

AutomotiveBanner.propTypes = {
  fitment: shape({})
};

AutomotiveBanner.defaultProps = {
  fitment: null
};

AutomotiveBanner.displayName = 'AutomotiveBanner';

export { AutomotiveBanner };
